function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import PropTypes from 'prop-types';
import * as React from 'react';
import { createShorthandFactory, getUnhandledProps, isBrowser } from '../../lib';
import Portal from '../../Portal';
import DimmerDimmable from './DimmerDimmable';
import DimmerInner from './DimmerInner';

/**
 * A dimmer hides distractions to focus attention on particular content.
 */
var Dimmer = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var active = props.active,
    page = props.page;
  var rest = getUnhandledProps(Dimmer, props);
  if (page) {
    var handlePortalMount = function handlePortalMount() {
      if (!isBrowser()) {
        return;
      }

      // Heads up, IE doesn't support second argument in add()
      document.body.classList.add('dimmed');
      document.body.classList.add('dimmable');
    };
    var handlePortalUnmount = function handlePortalUnmount() {
      if (!isBrowser()) {
        return;
      }

      // Heads up, IE doesn't support second argument in add()
      document.body.classList.remove('dimmed');
      document.body.classList.remove('dimmable');
    };
    return /*#__PURE__*/React.createElement(Portal, {
      closeOnEscape: false,
      closeOnDocumentClick: false,
      onMount: handlePortalMount,
      onUnmount: handlePortalUnmount,
      open: active,
      openOnTriggerClick: false
    }, /*#__PURE__*/React.createElement(DimmerInner, _extends({}, rest, {
      active: active,
      page: page,
      ref: ref
    })));
  }
  return /*#__PURE__*/React.createElement(DimmerInner, _extends({}, rest, {
    active: active,
    page: page,
    ref: ref
  }));
});
Dimmer.displayName = 'Dimmer';
Dimmer.propTypes = {
  /** An active dimmer will dim its parent container. */
  active: PropTypes.bool,
  /** A dimmer can be formatted to be fixed to the page. */
  page: PropTypes.bool
};
Dimmer.Dimmable = DimmerDimmable;
Dimmer.Inner = DimmerInner;
Dimmer.create = createShorthandFactory(Dimmer, function (value) {
  return {
    content: value
  };
});
export default Dimmer;
//# sourceMappingURL=Dimmer.js.map